<template>
  <div style="padding-top: 30px">
    <el-form :model="roleFrom" label-width="100px">
      <el-form-item label="组立管理" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="物件批号进度(组立)" name="type">物件批号进度</el-checkbox>
          <el-checkbox label="排产日历(组立)" name="type">排产日历</el-checkbox>
          <el-checkbox label="排产计划(组立)" name="type">排产计划</el-checkbox>
          <el-checkbox label="工人管理(组立)" name="type">工人管理</el-checkbox>
          <el-checkbox label="产线生产日报(组立)" name="type">产线生产日报</el-checkbox>
          <el-checkbox label="设备报修(组立)" name="type">设备报修</el-checkbox>
          <el-checkbox label="备品入库(组立)" name="type">备品入库</el-checkbox>
          <el-checkbox label="备品出库(组立)" name="type">备品出库</el-checkbox>
          <el-checkbox label="材料查找(组立)" name="type">材料查找</el-checkbox>
          <el-checkbox label="线外生产日报(组立)" name="type">线外生产日报</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="加工管理" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="物件批号进度(加工)" name="type">物件批号进度</el-checkbox>
          <el-checkbox label="生产日报(加工)" name="type">生产日报</el-checkbox>
          <el-checkbox label="工人管理(加工)" name="type">工人管理</el-checkbox>
          <el-checkbox label="设备报修(加工)" name="type">设备报修</el-checkbox>
          <el-checkbox label="备品入库(加工)" name="type">备品入库</el-checkbox>
          <el-checkbox label="备品出库(加工)" name="type">备品出库</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="涂装管理" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="物件批号进度(涂装)" name="type">物件批号进度</el-checkbox>
          <el-checkbox label="排产计划(涂装)" name="type">排产计划</el-checkbox>
          <el-checkbox label="生产日报(涂装)" name="type">生产日报</el-checkbox>
          <el-checkbox label="工人管理(涂装)" name="type">工人管理</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="制造设备管理" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="设备巡检(设备)" name="type">设备巡检</el-checkbox>
          <el-checkbox label="设备保养(设备)" name="type">设备保养</el-checkbox>
          <el-checkbox label="设备维修(设备)" name="type">设备维修</el-checkbox>
          <el-checkbox label="备品入库(设备)" name="type">备品入库</el-checkbox>
          <el-checkbox label="备品出库(设备)" name="type">备品出库</el-checkbox>
          <el-checkbox label="设备资料(设备)" name="type">设备资料</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="addRoleApp">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "MfgAppPermission",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      roleFrom: {},
      loading: false
    }
  },
  methods:{
    async addRoleApp(){
      this.loading = true;
      let {data: res} = await this.$axios.post('/mfgApp/user/addAppPermission',this.roleFrom);
      this.loading = false;
      if (!res.success) {
        this.$message.error(res.message);
      } else {
        this.$message.success('App权限编辑成功');
      }
    },
    async getAppList(){
      let {data: res} = await this.$axios.get('/mfgApp/user/permission?id='+this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.roleFrom.id = this.parentData.id
        this.roleFrom.name = this.parentData.name
        this.roleFrom.iconList = res.data
      }
    }
  },
  created() {
    this.getAppList()
  }
}
</script>

<style scoped>

</style>
